<div class="cta-select">
  <label class="cta__radio cta__radio--{{ input.value }} stock-radio" *ngFor="let input of data.input">
    <div class="stock-radio__option" [ngClass]="{selected: value === input.value}" (click)="onUpdate(name, input.value)">
      <span class="stock-radio__check"></span>
      <span class="stock-radio__label">{{input.label}}</span>
    </div>
  </label>
</div>
